import moment from 'moment';
import { openPrintWindow, escapeHtml } from '../MedicineOrders/printDispenseAuthorization';
import { buildMinistryPrintHtml } from '../../Shared/printLayout';

function fmtDate(v) {
    if (!v) return '—';
    try { return moment(v).format('YYYY/MM/DD HH:mm'); } catch { return '—'; }
}

export function buildDamageReportHtml(detail) {
    const infoHtml = `
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>المرفق</th><td>${escapeHtml(detail.branchName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>الصنف</th><td>${escapeHtml(detail.productName || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>التشغيلة</th><td>${escapeHtml(detail.batchNumber || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>الكمية</th><td>${Number(detail.quantity || 0)}</td></tr>
              <tr class="bg-gray-striped-1"><th>السبب</th><td>${escapeHtml(detail.reasonLabel || '—')}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>الحالة</th><td>${escapeHtml(detail.statusLabel || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>الملاحظة</th><td>${escapeHtml(detail.note || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>ملاحظة المراجعة</th><td>${escapeHtml(detail.reviewNote || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>أنشئ</th><td>${escapeHtml(fmtDate(detail.createdOn))} - ${escapeHtml(detail.createdByName || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>رُوجع</th><td>${escapeHtml(fmtDate(detail.reviewedOn))} - ${escapeHtml(detail.reviewedByName || '—')}</td></tr>
            </tbody>
          </table>
        </div>`;

    const signaturesHtml = `
        <div class="col-4"><p><strong>مقدم البلاغ</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>لجنة/مسؤول المراجعة</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>الختم الرسمي</strong><br/>الاسم: ............................<br/>التوقيع والختم: ............................</p></div>`;

    return buildMinistryPrintHtml({
        title: 'محضر بلاغ تالف',
        docRef: detail.code || detail.id || detail.productName || '',
        infoHtml,
        signaturesHtml,
        footerSummary: `وثيقة متابعة للأصناف التالفة صادرة عن ${escapeHtml('وزارة الصحة')}؛ تُستخدم للطباعة والأرشفة ضمن إجراءات التخلص أو المعالجة المعتمدة.`,
        footerMeta: `مرجع البلاغ: <strong>${escapeHtml(detail.code || String(detail.id || ''))}</strong>`
    });
}

export function printDamageReport(detail) {
    return openPrintWindow(buildDamageReportHtml(detail));
}
